import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
export function Guarantee() {
  return <section className="bg-sand py-20 sm:py-24" aria-labelledby="garantia-title" style={{
    paddingTop: "50px",
    paddingBottom: "50px"
  }} data-id="element-101" data-mp="1o2lsv5zg4o2z">
      <div className="mx-auto max-w-4xl px-6" data-id="element-102" data-mp="22126zhzn1gv5">
        <Reveal data-id="element-103" data-mp="1x5d53805bnvo">
          <div className="rounded-3xl border border-cream-line bg-cream px-8 py-12 text-center sm:px-14" data-id="element-104" data-mp="1x4uxxgby3p8z">
            <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-mint-700 text-white" data-id="element-105" data-mp="19f0ol8qu4ith">
              <ShieldCheckIcon className="h-7 w-7" aria-hidden="true" data-id="element-106" data-mp="14dte31xb55j4" />
            </span>
            <h2 id="garantia-title" className="mt-6 font-display text-3xl text-ink sm:text-4xl" data-id="element-107" data-mp="1j6n8rul5hs8d">
              Garantía de 7 días
            </h2>
            <p className="mx-auto mt-5 max-w-xl text-lg leading-relaxed text-ink-soft" data-id="element-108" data-mp="qnhmd44mx8si">
              Abres los 3 tomos. Revisas los 5 bonos. Pruebas una receta o armas tu primera cotización. Si en 7 días no es lo que esperabas,{' '}
              <strong className="font-semibold text-ink" data-id="element-109" data-mp="oz025robrumq">
                te devolvemos el 100%
              </strong>
              .
            </p>
            <p className="mt-4 font-display text-2xl text-mint-700" data-id="element-110" data-mp="ypkx954sih0w">
              Sin preguntas. Sin formularios. Sin drama.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}